<template>
  <div class="bg-light p-3 mt-3 sidebar-sub-container" id="partner">
      <p class="sidebar-sub-container-body">
          {{$t('vue.checkout.sidebar.partner.informationAboutMoreOrLessKm')}}
    </p>

    <p class="sidebar-sub-container-body">
        {{$t('vue.checkout.sidebar.partner.informationAboutNonDrivenKm')}}
    </p>

    <p class="sidebar-sub-container-body">
        {{$t('general.deductibleInsurance')}}
        <br>
        {{$t('general.liabilityInsurancePre')}}
      <br>
      {{$t('general.liabilityInsurancePost')}}
        <br>
        {{$t('general.fullyComprehensiveInsurancePre')}}
        <br>
      {{$t('general.fullyComprehensiveInsurancePost')}}
      <br>
        {{$t('general.partialComprehensiveInsurancePre')}}
      <br>
      {{$t('general.partialComprehensiveInsurancePost')}}
      <br>
        {{$t('general.parkingDamagePre')}}<br>
      {{$t('general.parkingDamagePost')}}<br>
       <br>
    </p>

    <p class="sidebar-sub-container-body">
        {{$t('general.onlyForUnder25')}}
    </p>
  </div>
</template>

<script>
export default {
  name: "Partner",
  props: {
    currency: {
      type: String,
      default: "€"
    },
    toleranceLimits: {
      type: Array,
      required: true
    },
    vehicle: {
      type: Object,
      required: true
    },
    subscription: {
      type: Object,
      required: true
    },
    defaultDamageParticipation: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      damageParticipation: {}
    };
  },
  methods: {
    formatPrice (value) {
      let val = (value / 1).toFixed (2).replace ('.', ',');
      return val.toString ().replace (/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  },
  computed: {
    participation () {

      let damage_participation = this.subscription.damage_participation;
      if (typeof damage_participation === 'undefined' || damage_participation === null) {
        return this.formatPrice (this.defaultDamageParticipation);
      } else {
        return this.formatPrice (damage_participation.participation);
      }
    },
    toleranceLimit () {
      let self = this
      let limit = this.toleranceLimits.find (function (toleranceLimit) {
        return toleranceLimit.mileage === self.subscription.mileage.mileage
      });

      if (limit != null) {
        return limit.pivot.allowed_additional_km
      }
      return "FEHLER"
    }
  }
}
</script>

<style scoped lang="scss">
p {
  &.sidebar-sub-container-body {
    font-size: .8em !important;
    line-height: 1.3;
  }
}
</style>
